module.exports = __webpack_public_path__ + "static/media/infoimage.46fe578f.jpg";